/**
 * Product Catalog Management
 * ## TMF API Reference: TMF620 - Product Catalog Management  ### Release : 19.0 - June 2019  Product Catalog API is one of Catalog Management API Family. Product Catalog API goal is to provide a catalog of products.   ### Operations Product Catalog API performs the following operations on the resources : - Retrieve an entity or a collection of entities depending on filter criteria - Partial update of an entity (including updating rules) - Create an entity (including default values and creation rules) - Delete an entity - Manage notification of events
 *
 * OpenAPI spec version: 4.0.0
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */


/**
 * Valid values for the state of a batch job (e.g. catalog import)
 */
export type JobStateType = 'Not Started' | 'Running' | 'Succeeded' | 'Failed';

export const JobStateType = {
    NotStarted: 'Not Started' as JobStateType,
    Running: 'Running' as JobStateType,
    Succeeded: 'Succeeded' as JobStateType,
    Failed: 'Failed' as JobStateType
};
